module.exports = __webpack_public_path__ + "img/download_mac_text.e6598f60.png";